<template>
  <div class="outpatient-box">
    <van-sidebar v-model="activeKey" @change="titleChange">
      <van-sidebar-item
        v-for="(item, index) in titleList"
        :key="index"
        :title="item.titleName"
      />
    </van-sidebar>
    <div v-if="doctor.length" class="list">
      <van-cell
        v-for="(item, index) in doctor"
        :key="`doctor${index}`"
        @click="doctorInfoFun(item)"
      >
        <div slot="icon">
          <img class="doctor-img" src="../../assets/images/doctor.png">
        </div>
        <div slot="title" style="font-weight: 600">
          {{ item.doctorName }}
        </div>
        <div slot="label">
          <van-button type="info">
            <img src="../../assets/images/v_pic.png" alt="" style="width: 25%">
            {{ item.titleName }}</van-button>
          <div class="good">{{ item.doctorGood }}</div>
        </div>
        <!-- <div slot="right-icon">
          <van-icon class="doctor-right-icon" name="arrow" />
        </div> -->
      </van-cell>
    </div>
    <NoData v-else />
    <van-overlay
      class="loading-center"
      :show="dataLoading"
      @click="show = false"
    >
      <van-loading size="50" />
    </van-overlay>
  </div>
</template>
<script>
export default {
  name: 'YiShengJieShao',
  data() {
    return {
      doctor: [],
      id: '',
      dataLoading: false,
      doctorList: [],
      keepList: [],
      activeKey: 0,
      titleList: []
    }
  },
  created() {
    this.getDeptList()
  },
  mounted() {},
  methods: {
    getDeptList() {
      this.$Apis.getSzsgjyyDoctorJobList().then(res => {
        if (res.code === 200) {
          this.titleList = res.data.filter(item => item.titleCode)
          this.getDoctorList(res.data[0].titleCode)
        }
      })
    },
    getDoctorList(titleCode) {
      this.dataLoading = true
      this.$Apis
        .getSzsgjyyDoctorJobTitleInfo({ titleCode })
        .then(res => {
          this.dataLoading = false
          if (res.code === 200) {
            this.doctor = res.data
          } else {
            this.doctor = []
          }
        })
        .catch(() => {
          this.doctor = []
          this.dataLoading = false
        })
    },
    doctorInfoFun(item) {
      this.$router.push(
        `/yishengDetails?doctorCode=${item.doctorCode}&deptCode=${item.deptCode}`
      )
    },
    titleChange(index) {
      const { titleCode } = this.titleList[index]
      this.getDoctorList(titleCode)
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-sidebar-item--select {
  background-color: #2b8cff;
  color: #fff;
}
.doctor-img {
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  margin-right: 0.1rem;
}

.doctor-right-icon {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  margin-left: 5px;
  color: #969799;
}
.list {
  position: absolute;
  top: 0;
  left: 100px;
  height: 100vh;
  overflow-y: auto;
}
.loading-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.van-cell {
  align-items: center;
  border-bottom: 1px solid #e8eeee;
}
.van-sidebar {
  width: 1rem;
}
.van-sidebar {
  height: 100%;
  position: relative;
}
.van-sidebar-item--select::before {
  display: none;
}
.van-button {
  height: 24px;
  padding: 5px;
  padding-left: 0;
  border-radius: 10px;
}
.good {
  margin-top: 10px;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; // 显示几行
  -webkit-box-orient: vertical;
}
</style>
